import { render, staticRenderFns } from "./TemplateWhatsappOficial.vue?vue&type=template&id=7bb6deb4"
import script from "./TemplateWhatsappOficial.vue?vue&type=script&lang=js"
export * from "./TemplateWhatsappOficial.vue?vue&type=script&lang=js"
import style0 from "./TemplateWhatsappOficial.vue?vue&type=style&index=0&id=7bb6deb4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports